import { useState } from "react"
import arrowDown from '../assets/new-ui/arrow-down-white.png'
import arrowUp from '../assets/new-ui/arrow-up-white.png'
import parse from 'html-react-parser'
export default function FAQElement(props) {
  const {question, answer} = props
  const [showAnswer, setShowAnswer] = useState(false)

  return (
    <div className='FAQElement' onClick={() => setShowAnswer(old => !old)}>
      <div className='title'>
        <div>{question}</div>
      </div>
      {
        showAnswer
          ? <div className='detail'>{parse(answer)}</div>
          : ''
      }
      {
        showAnswer
          ? <img src={arrowUp} alt='arrow up' />
          : <img src={arrowDown} alt='arrow down' />
      }
    </div>
  )
}